import { createContext, useContext, ReactNode, useState } from "react";

export type UIConfiguration = {
  hideCloseButton: boolean;
};

export const UIConfigurationContext = createContext<UIConfiguration>({
  hideCloseButton: false,
});

export type UIConfigurationProviderProps = {
  children: ReactNode;
};

export const UIConfigurationProvider: React.FC<
  UIConfigurationProviderProps
> = ({ children }) => {
  const [hideCloseButton] = useState(() => {
    // Capture the initial query parameter value and persist it for the session
    const params = new URLSearchParams(window.location.search);
    return params.get("hide_close_button") === "true";
  });

  const value: UIConfiguration = {
    hideCloseButton,
  };

  return (
    <UIConfigurationContext.Provider value={value}>
      {children}
    </UIConfigurationContext.Provider>
  );
};

export const useUIConfiguration = () => {
  return useContext(UIConfigurationContext);
};
